// Converts a Date to a string in dd/mm/yyyy format.
export const convertToStartDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Parses a dd/mm/yyyy string to a Date object.
export const parseDateFromString = (dateString: string) => {
  const [day, month, year] = dateString.split("/");
  return new Date(
    parseInt(year, 10),
    parseInt(month, 10) - 1,
    parseInt(day, 10)
  );
};
